import React from "react";
import { formatCurrency } from "../../../../../utils/Utils";

interface Props {
  watch: any;
  totalAmount: number;
  vendeurDevise?: string;
}

function Confirmation({ watch, totalAmount, vendeurDevise }: Props) {
  const nom = watch ? watch("nom_complet") : "";
  const telephone = watch ? watch("telephone") : "";
  const date = watch ? watch("date_rendez_vous") : "";
  const heure = watch ? watch("heure_rendez_vous") : "";
  const typeConsultation = watch ? watch("type_consultation") : "";

  return (
    <div className="service-form-card service-confirmation">
      <div className="service-confirmation-icon">✓</div>
      <h2>Récapitulatif de votre rendez-vous</h2>
      <p className="service-form-subtitle">
        Veuillez vérifier les informations ci-dessous avant de confirmer.
      </p>

      <div className="service-summary-list">
        <div className="service-summary-row">
          <span>Nom complet</span>
          <span>{nom || "-"}</span>
        </div>
        <div className="service-summary-row">
          <span>Téléphone</span>
          <span>{telephone || "-"}</span>
        </div>
        <div className="service-summary-row">
          <span>Date</span>
          <span>{date || "-"}</span>
        </div>
        <div className="service-summary-row">
          <span>Heure</span>
          <span>{heure || "-"}</span>
        </div>
        <div className="service-summary-row">
          <span>Type de consultation</span>
          <span>{typeConsultation || "-"}</span>
        </div>
        <div className="service-summary-row">
          <span>Montant total</span>
          <span className="fw-bold">
            {formatCurrency(totalAmount, vendeurDevise)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;